const _ = require('lodash');

module.exports = function (items) {
    return {
        event: 'addToTrolley',
        ecommerce: {
            currencyCode: 'AUD',
            add: {
                products: _.map(items, item => ({
                    name: item.Name,
                    quantity: item.Quantity,
                    id: item.Stockcode,
                    listprice: item.ListPrice,
                    price: item.SalePrice,
                    variant: item.PackageSize,

                    missedpromotions: _.map(item.MissedPromotions, missedPromotion => ({
                        id: missedPromotion.ID,
                        description: missedPromotion.Description,
                        link: missedPromotion.Link,
                        ismultibuy: missedPromotion.IsMultiBuy,
                        ispackageprice: missedPromotion.IsPackagePrice,
                        isbonusoffer: missedPromotion.IsBonusOffer,
                        isproductgrouppercentageoff: missedPromotion.IsProductGroupPercentageOff,
                    })),

                    matchedpromotions: _.map(item.MatchedPromotions, matchedpromotion => ({
                        id: matchedpromotion.ID,
                        description: matchedpromotion.Description,
                        link: matchedpromotion.Link,
                        ismultibuy: matchedpromotion.IsMultiBuy,
                        ispackageprice: matchedpromotion.IsPackagePrice,
                        isbonusoffer: matchedpromotion.IsBonusOffer,
                        isproductgrouppercentageoff: matchedpromotion.IsProductGroupPercentageOff,
                    })),
                })),
            },
        },
    };
};



// WEBPACK FOOTER //
// ./src/shop/trolley/gtmmapper/trolley-addall-analytics-mapper.js